import { render, staticRenderFns } from "./AssignToClassWrapper.vue?vue&type=template&id=43cea11c&scoped=true&"
import script from "./AssignToClassWrapper.vue?vue&type=script&lang=js&"
export * from "./AssignToClassWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43cea11c",
  null
  
)

export default component.exports